import { useState, useEffect } from 'react';
import Header from './include/header';
import Footer from './include/footer';
import LeftPanel from './include/FinanceLeftPanel';
import { useNavigate } from 'react-router-dom';
import Global from '../APIConfig';
import  axios from "axios";
import AuthUser from "../AuthUser";
import SaleChart from './Charts/SaleChart';
import CashChart from './Charts/CashChart';
import CreditChart from './Charts/CreditChart';
import WalletChart from './Charts/WalletChart';
import CodChart from './Charts/CodChart';

function FinanceDashBoard() {
    let navigate = useNavigate();
    const{headers1,logout}=AuthUser();
    const [totalrevenue, setTotalrevenue] = useState('');
    const [totalCash, setTotalCash] = useState('0');
    const [totalCredit, setTotalCredit] = useState('0');
    const [totalWallet, setTotalWallet] = useState('0');
    const [totalCod, setTotalCod] = useState('0');

    useEffect(() => {
        Get30DaysRevenue();
        Get30DaysCash();
        Get30DaysCredit();
        Get30DaysWallet();
        Get30DaysCod();
      }, []);
      const Get30DaysRevenue=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysRevenue',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalrevenue(data.label);
                
            }
            else
            {
                setTotalrevenue(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }
    const Get30DaysCash=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysCash',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalCash(data.label);
                
            }
            else
            {
                setTotalCash(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }
    const Get30DaysCredit=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysCredit',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalCredit(data.label);
                
            }
            else
            {
                setTotalCredit(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }
    const Get30DaysWallet=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysWallet',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalWallet(data.label);
                
            }
            else
            {
                setTotalWallet(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }
    const Get30DaysCod=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysCod',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalCod(data.label);
                
            }
            else
            {
                setTotalCod(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }
  return (
    <>
        <LeftPanel/>
        <main className='home-section'>
        <Header/>
        <div className="overlay"></div>
        <div className='col-12 mt-4'><h2>Finance Dashboard</h2></div>
        <div className="row dash_state_box">
                <div className="col-12 col-md-6 col-sm-6 col-xl-4 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-collection"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> Revenue</h2>
                                        <h3 className="mb-1">{Number(totalrevenue).toFixed(2)}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> Revenue</h2>
                                        <h3 className="">{Number(totalrevenue).toFixed(2)}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-sm-6 col-xl-4 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-cuboid"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5">Credit</h2>
                                        <h3 className="mb-1">{Number(totalCredit).toFixed(2)}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> Credit</h2>
                                        <h3 className="">{Number(totalCredit).toFixed(2)}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-sm-6 col-xl-4 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-package"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> Cash</h2>
                                        <h3 className="mb-1">{Number(totalCash).toFixed(2)}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> Cash</h2>
                                        <h3 className="">{Number(totalCash).toFixed(2)}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-sm-6 col-xl-6 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-run"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> Wallet</h2>
                                        <h3 className="mb-1">{Number(totalWallet).toFixed(2)}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> Wallet</h2>
                                        <h3 className="">{Number(totalWallet).toFixed(2)}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-sm-6 col-xl-6 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-run"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> COD</h2>
                                        <h3 className="mb-1">{Number(totalCod).toFixed(2)}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> COD</h2>
                                        <h3 className="">{Number(totalCod).toFixed(2)}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 col-md-8'>
                        <section className="mb-3">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="shipment_card_st shadow-sm">
                                        <SaleChart/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="sales_card_st shadow-sm">
                                        <CashChart/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 mt-2">
                                    <div className="shipment_card_st shadow-sm">
                                        <CreditChart/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 mt-2">
                                    <div className="sales_card_st shadow-sm">
                                        <WalletChart/>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 mt-2">
                                    <div className="sales_card_st shadow-sm">
                                        <CodChart/>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className='col-12 col-md-4'>
                        <div className="row">
                            <div className="list-group">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    Reports Management
                                </a>
                                <a href="/CustomerCreditOverview" className="list-group-item list-group-item-action">Customer Credit Reports</a>
                                <a href="/CustomerContractOverview" className="list-group-item list-group-item-action">Customer Cantrect Report</a>
                                <a href="/CustomerWalletOverview" className="list-group-item list-group-item-action">Customer Wallet Report</a>
                            </div>
                            <div className="list-group mt-4">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    Reports Management
                                </a>
                                <a href="/ShipmentReport" className="list-group-item list-group-item-action">Shipment Report</a>
                                <a href="/PaymentReport" className="list-group-item list-group-item-action">Payment Report</a>
                                <a href="/HubReport" className="list-group-item list-group-item-action">Hub Report</a>
                                <a href="/AgentReport" className="list-group-item list-group-item-action">Agent Report</a>
                                <a href="/DriverReport" className="list-group-item list-group-item-action">Driver Report</a>
                                <a href="/CODReport" className="list-group-item list-group-item-action">COD Report</a>
                            </div>
                            <div className="list-group mt-4">
                                <a href="#"  className="list-group-item list-group-item-action active">
                                    Stock Management
                                </a>
                                <a href="/Stocklist" className="list-group-item list-group-item-action">Stock Management</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <Footer/>
        </main>
    </>
  );
}

export default FinanceDashBoard;